module.exports = __webpack_public_path__ + "/8109ddc4f09423cea9324e227333a4eb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/teams_icon.svg
 ** module id = 1632
 ** module chunks = 0
 **/